export const BRAND = {
  logoLight: '/lovable-uploads/c41eac80-1235-4c5d-8ad9-92f025308beb.png',
  logoDark: '/lovable-uploads/c41eac80-1235-4c5d-8ad9-92f025308beb.png',
  alt: 'Cosmos Wave - Agence Amazon & IA'
} as const;

export const ORGANIZATION = {
  entity: "Cosmos Wave",
  type: "Organization",
  tagline: {
    fr: "Agence Amazon-first : digital shelf, marketplaces et croissance pilotée par la data.",
    en: "Amazon-first agency for digital shelf, marketplaces and data-driven growth."
  },
  website: "https://www.cosmos-wave.com",
  contact: { 
    email: "contact@cosmos-wave.com" 
  },
  services: [
    "Amazon A–Z (setup, Brand Registry, ops, Buy Box)",
    "Listings, A+ Content & Stores", 
    "Amazon Ads (SP/SB/SD/DSP)",
    "Other marketplaces (Cdiscount, Rakuten, etc.)",
    "E-commerce (Shopify/WooCommerce)",
    "Creative studio (photo/vidéo/visuels)",
    "Reporting & KPIs"
  ],
  industries: ["Beauty", "Food & Beverage", "Home & Living", "Electronics"],
  geographies: ["France", "UE"],
  aliases: ["Cosmos Wave Agency", "CosmosWave"],
  proofs: [
    {
      label: "Accompagnement Amazon", 
      url: "https://www.cosmos-wave.com/accompagnement-amazon"
    }
  ]
} as const;